// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".web-root[data-v-447fbda4]{width:100%;height:100vh;overflow-y:hidden;display:flex;flex-direction:column}.web-root .page-container[data-v-447fbda4]{box-sizing:border-box;background-color:#000;padding:0;flex:1;display:flex;flex-direction:column}.web-root .page-container .mobile-bar[data-v-447fbda4]{width:100%}.web-root .page-container #offical-web-iframe[data-v-447fbda4]{flex:1;width:100%}", ""]);
// Exports
module.exports = exports;
